import {
  CREATE_ANNUAL_SOLAR_REPORT,
  DELETE_ANNUAL_SOLAR_REPORT,
  EDIT_ANNUAL_SOLAR_REPORT,
  RECEIVE_ANNUAL_SOLAR_REPORTS,
  REQUEST_ANNUAL_SOLAR_REPORT,
} from '@sophocles/entities/AnnualSolarReport/annualSolarReportActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_ANNUAL_SOLAR_REPORTS: // Read
      return state.merge(action.annualSolarReports);
    case DELETE_ANNUAL_SOLAR_REPORT: // Delete
      return state.delete(action.annualSolarReport.toString());
    case EDIT_ANNUAL_SOLAR_REPORT: // Update
    case CREATE_ANNUAL_SOLAR_REPORT: // Create
    case REQUEST_ANNUAL_SOLAR_REPORT:
    default:
      return state;
  }
}

export function annualSolarReportReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_ANNUAL_SOLAR_REPORT:
    case DELETE_ANNUAL_SOLAR_REPORT:
    case RECEIVE_ANNUAL_SOLAR_REPORTS:
    case EDIT_ANNUAL_SOLAR_REPORT:
    case REQUEST_ANNUAL_SOLAR_REPORT:
      return getState(state, action);
    default:
      return state;
  }
}
